// src/store/modules/member.js
import { Login } from "@/api/login.js";
import router from '@/router/index.js';
// 会员模块的状态
const state = {
  // 会员信息
  profile: {
    usertype: '0',//登录身份 0为游客 1调度 2司机 
    examineflg: 0, //审核标识:0:待审核1:审核通过，2:未通过 
    paystatus: 0, //支付状态 1:已支付，0:未支付 
    validstatus: 0, //有效状态， 1:有效注册，0:无效注册 
  },
  // 分享人信息
  introduceInfo: {
    introducephone: '',
    introduceNo: ''
  }
};

// 会员模块的mutations
const mutations = {
  // 设置会员信息
  SET_PROFILE(state, profile) {
    state.profile = profile;
  },
  // 设置分享人信息
  SET_INTRODUCE_INFO(state, introduceInfo) {
    state.introduceInfo = introduceInfo;
  },
  // 更新会员信息的部分字段
  UPDATE_PROFILE(state, partialProfile) {
    state.profile = {
      ...state.profile,
      ...partialProfile
    };
  },
  // 清理会员信息
  CLEAR_PROFILE(state) {
    state.profile = {
      usertype: '0',//登录身份 0为游客 1调度 2司机 
      examineflg: 0, //审核标识:0:待审核1:审核通过，2:未通过 
      paystatus: 0, //支付状态 1:已支付，0:未支付 
      validstatus: 0, //有效状态， 1:有效注册，0:无效注册 
    };
    // 同时清理分享人信息
    state.introduceInfo = {
      introducephone: '',
      introduceNo: ''
    };
  },
  // 清理分享人信息
  CLEAR_INTRODUCE_INFO(state) {
    state.introduceInfo = {
      introducephone: '',
      introduceNo: ''
    };
  }
};

// 会员模块的actions
const actions = {
  // 登录操作
  login({ commit }, data) {
    // 显示登录成功提示（在Vue2中可以使用其他方式如Element UI等）
    console.log('登录成功');
    // 设置会员信息
    commit('SET_PROFILE', data);
  },
  // 处理登录后的逻辑 兼容老逻辑
  async handleLoginSuccess({ commit, dispatch }, data) {
    localStorage.setItem('usertype', data.usertype);
    localStorage.setItem('validstatus', data.validstatus);
    localStorage.setItem('usercode', data.usercode);
    localStorage.setItem('userid', data.userid);
    localStorage.setItem('phone', data.phone);
    localStorage.setItem('authenticationflag', data.authenticationflag);
    localStorage.setItem('companyname', data.companyname);
    
    // 处理Android WebView
    if (window.AndroidWebView) {
      // 处理推送token
      let res = await CSDK.getPushtoken();
      console.log('getPushtoken获取token1', CSDK._getPlatform(), res);
      let r = JSON.parse(res);
      console.log('getPushtoken获取token2', r);
  
      if (r) {
        const pushmodel = r.pushmodel || "";
        const pushtoken = r.pushtoken || '';
        console.log('getPushtoken获取token3', pushmodel, pushtoken);
  
        if (pushtoken) {
          let obj = {
            "model": pushmodel,
            "token": pushtoken,
          };
          console.log(1111);
  
          Login.UpdateToken(obj);
          console.log('2222');
        }
      }
      const phoneData = JSON.stringify({
        phone: data.phone,
        phonetype: "Android",
      });
      AndroidWebView.setPhone(phoneData);
    }

    // 根据注册状态决定跳转路径
    if (data.validstatus == '0') {
      router.push({
        name: 'role'
      });
    } else {
      router.push({
        name: 'home'
      });
    }
  },
  // 设置分享人信息
  setIntroduceInfo({ commit }, introduceInfo) {
    commit('SET_INTRODUCE_INFO', introduceInfo);
  },
  // 更新会员信息的部分字段
  updateProfile({ commit }, partialProfile) {
    commit('UPDATE_PROFILE', partialProfile);
  },
  // 清理会员信息（退出登录）
  clearProfile({ commit }) {
    commit('CLEAR_PROFILE');
  },
  // 清理分享人信息
  clearIntroduceInfo({ commit }) {
    commit('CLEAR_INTRODUCE_INFO');
  }
};

// 会员模块的getters
const getters = {
  // 获取会员信息
  profile: state => state.profile,
  // 获取分享人信息
  introduceInfo: state => state.introduceInfo,
  // 获取用户类型
  usertype: state => state.profile.usertype,
  // 判断是否已登录（非游客状态）
  isLoggedIn: state => state.profile.usertype !== '0'
};

export default {
  namespaced: true, // 开启命名空间
  state,
  mutations,
  actions,
  getters
};


// WEBPACK FOOTER //
// ./src/store/modules/member.js